// extracted by mini-css-extract-plugin
export default {"link":"XzB_u0Nc_BU6qunaSAl0"};